import React from "react";
import type { BaseProvinceIconProps } from "./BaseProvinceIcon";

export const NewfoundLandIcon = (props: BaseProvinceIconProps) => {
  return (
    <g
      id="NL"
      {...props}
    >
      <path
        d="M260.6,151.7c0.2,0,0.4,0.1,0.5,0.2c5,4.5,10,9,15,13.5c1.6,1.4,3,3.7,5.1,4.4c1.7,0.6,4,0.1,5.7-0.1
            c2.4-0.3,4.7-0.7,7-1.2c1.7-0.3,3.7-1.1,5.4-1.1c0.5,0,0.8,0.4,0.8,0.8l-0.8,4.6c-0.1,0.4,0.3,0.8,0.7,0.8c0.2,0,0.3-0.1,0.5-0.2
            l5.5-5.3c0.1-0.1,0.2-0.2,0.4-0.2c0.6,0,2-0.1,3.8-0.2c0.2,0,0.4,0.1,0.5,0.2c0.3,0.3,0.6,0.7,1,0.9c0.1,0,0.1,0,0.2,0
            c0.3,0,0.7-0.3,0.9-0.6c0.6-0.7,1.4-0.8,2.3-0.8c0.2,0,0.4,0,0.6,0c0.1,0,0.3,0,0.5,0c0.8,0,1.6,0.5,2.1,0.7
            c1.2,0.6,2.4,1.1,3.6,1.7c1.3,0.6,2.6,1.3,3.9,2c0.9,0.5,2.5,1,3.2,1.8c0.4,0.4,0.5,0.9,0.4,1.3c-0.3,1.1-2.6,4.9-3.2,6.1
            c-0.1,0.2-0.4,0.4-0.6,0.4s-0.3-0.1-0.5-0.2l-5.9-5.4c-0.1-0.1-0.3-0.2-0.5-0.2c-0.1,0-0.2,0-0.4,0.1c-3.8,2.3-8.3,5.4-12,7.8
            c-4.1,2.7-21.3,13.6-22.6,14.6c-0.5,0.4-0.9,0.6-1.3,0.6s-0.8-0.2-1.2-0.6c-5.4-4.5-10.9-8.8-16.5-13.3c-0.3-0.2-0.3-0.7-0.1-1
            c2.4-2.6,4.8-5.1,7.1-7.7c2.2-2.4,2.4-4.9,0.6-7.5c-2.7-3.9-4.5-6.2-8.4-10.9L260,153c-0.2-0.3-0.2-0.8,0-1
            C260.1,151.8,260.4,151.7,260.6,151.7L260.6,151.7z"
      />
      <path
        d="M330,178.5c0.1,0,0.2,0.1,0.4,0.4c0.8,1.7,1.5,3.4,2.3,5.2c0.7,1.6,1.4,3.2,2.1,4.8c0.1,0.3,0.3,0.5,0.6,0.6
            l5.1,1.9c0.1,0.1,0.2,0.1,0.4,0.1c0.2,0,0.5-0.1,0.6-0.2l4.8-3.8c0.2-0.1,0.4-0.2,0.6-0.2c0.1,0,0.3,0,0.4,0.1l7.5,3.1l0.6,0.1
            c0.1,0,2.6-0.4,4.6-0.7c0.1,0,0.2,0,0.3,0c0.9,0,1.7,0.6,1.9,1.6l1.1,6.2c0.2,1.2-0.7,2.3-1.9,2.3c-0.2,0-0.4,0-0.6-0.1
            c-0.9-0.3-1.8-0.6-2.7-0.9c0,0-0.1,0-0.2,0c-0.5,0-1,0.8-1,0.9c-0.8,1.4-1.6,2.8-2.4,4.1c-0.4,0.6-0.8,1.9-1.7,2c0,0-0.1,0-0.2,0
            c-0.8,0-1.5-0.6-2.1-0.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.6,0.1-0.8,0.4c-1.4,1.5-4.9,5.6-7.5,8.4c-0.4,0.4-0.9,0.6-1.5,0.6
            s-1.3-0.3-1.7-0.9c-0.1-0.2-0.2-0.3-0.3-0.5c-0.4-0.6-1-0.8-1.6-0.8c-0.1,0-0.2,0-0.3,0c-0.5,0-0.9-0.3-1-0.8
            c-0.1-1.6-2.1-12.8-3.2-16.6c-0.5-1.9-3.3-8.1-3.5-10c-0.1-1.1,0-2.2,0.1-3.2C329.1,180.7,329.5,178.5,330,178.5L330,178.5z"
      />
    </g>
  );
};
